<template>
  <el-card>
    <el-row>
      <el-col :span="18">&nbsp;</el-col>
      <el-col :span="6">
        <el-button v-if="showAdd" type="primary" @click="addBillingModel">添加账单模型</el-button>
        <el-button type="primary" @click="goBack">返回</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="list">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip v-if="showView" effect="light" placement="top-start" content="查看">
                <el-button type="text" @click="viewBillingModel(scope.row.id)"><i class="el-icon-view"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="showEdit" effect="light" placement="top-start" content="编辑">
                <el-button type="text" @click="editBillingModel(scope.row.id)"><i class="el-icon-edit"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="showDelete" effect="light" placement="top-start" content="删除">
                <el-button type="text" @click="deleteBillingModel(scope.row.id)"><i class="el-icon-delete"></i></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import {deleteSettingBillingModel, fetchSettingBillingModelList} from "@/api/billing";

export default {
  name: "setting-billing-model-list",
  data() {
    return {
      showView: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      query: {
        offset: 0,
        limit: 20
      },
      loading: false,
      branch_office_id: null,
      list: []
    }
  },
  methods:{
    addBillingModel: function() {
      this.$router.push({name: 'addSettingBillingModel', query:{branch_office_id: this.branch_office_id}})
    },
    goBack: function() {
      this.$router.go(-1)
    },
    viewBillingModel: function(id){
      this.$router.push({name: 'viewSettingBillingModel', query: {id:id}})
    },
    editBillingModel: function(id) {
      this.$router.push({name: 'editSettingBillingModel', query: {id:id}})
    },
    deleteBillingModel: function(id) {
      deleteSettingBillingModel(id)
          .then(resp=>{
            setTimeout(()=>{
              this.$message.success('成功删除账单模型')
              this.getList()
            }, 500)
          }).catch(err=>{
        this.$$error_message('err')
      })
    },
    getList() {
      this.loading = true
      fetchSettingBillingModelList(this.query, this.branch_office_id)
          .then( resp => {
            this.list = resp.results
            this.loading = false
          }).catch( err => {
        this.loading = false
        this.$error_message(err)
      })
    },
  },
  created(){
    // 权限检查
    if (!this.$perm(["billing.list_setting_billing_model"])) {
      this.$router.push('/401')
    }

    if (this.$route.query.branch_office_id === undefined){
      this.$router.push('/404')
    }
    this.branch_office_id = this.$route.query.branch_office_id
    console.log(this.branch_office_id)

    this.showView = true

    if (this.$perm(["billing.create_setting_billing_model"])) {
      this.showAdd = true
    }
    if (this.$perm(["billing.update_setting_billing_model"])) {
      this.showEdit = true
    }
    if (this.$perm(["billing.delete_setting_billing_model"])) {
      this.showDelete = true
    }

    this.getList()
  }
}
</script>

<style scoped>

</style>
